module.exports = __webpack_public_path__ + "fonts/fontello.9f01d90.woff2";